import booths from './booths';
import files from './files';
import workshop from './workshop';
import author from './author';
import agenda from './agenda';

export default { booths, files, workshop, author, agenda };
